<script setup>
defineProps({
  size: { type: String, default: '1em' },
  title: { type: String, default: '' },
});
</script>

<template>
  <span
    class="x-platform-icon-wrap"
    :title="title || undefined"
    :aria-label="title || 'X'"
  >
  <svg
    class="x-platform-icon"
    :style="{ width: size, height: size }"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill="currentColor"
      d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
    />
  </svg>
  </span>
</template>

<style scoped>
.x-platform-icon-wrap {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  flex-shrink: 0;
  line-height: 0;
}

.x-platform-icon {
  display: block;
}
</style>
